/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface GoogleLoginButtonArgs {
  theme?: 'light' | 'dark';
}

export default class GoogleLoginButton extends Component<GoogleLoginButtonArgs> {
  loginGoogleLogoImage = new URL('cio/assets/images/login-google-logo.svg', import.meta.url).toString();

  get theme() {
    return this.args.theme ?? 'light';
  }
}
